import { FC } from 'react'
import { SvgProps } from './svgProps'

const ShirtIcon: FC<SvgProps> = ({ width, height, color }) => (
  <svg
    version="1.1"
    xmlns="http://www.w3.org/2000/svg"
    width={width || 32}
    height={height || 32}
    viewBox="0 0 32 32"
  >
    <path
      fill="none"
      strokeLinejoin="round"
      strokeLinecap="round"
      strokeMiterlimit="4"
      strokeWidth="0.8366"
      stroke={color || '#000'}
      d="M21.632 1.794l3.884 1.845c0.83 0.4 1.431 1.161 1.603 2.074l0.003 0.018 4.363 23.172-4.202 1.173-3.275-16.941v18.296h-16.111v-18.305l-3.277 16.941-4.202-1.175 4.363-23.172c0.175-0.931 0.776-1.692 1.589-2.084l0.017-0.008 3.892-1.834"
    ></path>
    <path
      fill="none"
      strokeLinejoin="round"
      strokeLinecap="round"
      strokeMiterlimit="4"
      strokeWidth="0.8366"
      stroke={color || '#000'}
      d="M10.826 0.627l5.133 5.321-3.411 1.999-2.267-6.153 0.546-1.167z"
    ></path>
    <path
      fill="none"
      strokeLinejoin="round"
      strokeLinecap="round"
      strokeMiterlimit="4"
      strokeWidth="0.8366"
      stroke={color || '#000'}
      d="M21.093 0.627l-5.135 5.321 3.413 1.999 2.267-6.153-0.546-1.167z"
    ></path>
    <path
      fill="none"
      strokeLinejoin="round"
      strokeLinecap="round"
      strokeMiterlimit="4"
      strokeWidth="0.8366"
      stroke={color || '#000'}
      d="M10.826 0.627h10.267"
    ></path>
    <path
      fill="none"
      strokeLinejoin="round"
      strokeLinecap="round"
      strokeMiterlimit="4"
      strokeWidth="0.8366"
      stroke={color || '#000'}
      d="M15.958 5.948v25.474"
    ></path>
  </svg>
)

export default ShirtIcon
